/** @jsx jsxPragma */

import React from "react";

import jsxPragma from "./jsxPragma";

import type { ImageProps } from "@outschool/ui-utils";

/**
 * An implementation of `Image` currently in use in website/learnerapp.
 * Each front-end side app that uses the ImageComponentProvider should
 * have its own implementation of this. Marked as deprecated to provide
 * a hint to devs not to import it directly.
 *
 * @deprecated Import `useImageComponent` from `@outschool/ui-utils` instead.
 */
function Image(
  { sx, alt = "", ...props }: ImageProps,
  ref: React.Ref<HTMLImageElement>
) {
  // @ts-ignore
  // eslint-disable-next-line i18next/no-literal-string
  return <img ref={ref} sx={sx} alt={alt} {...props} />;
}

/**
 * @deprecated Import `useImageComponent` from `@outschool/ui-utils` instead.
 */
export default React.forwardRef(
  Image
) as React.ForwardRefExoticComponent<ImageProps>;
